package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 顶层 `subscribe { ... }` 块 AST。
 *
 * 结构：subscribe { namespace { topic { handler = expr } } }
 *
 * `unknownFields` 用于把 parser 阶段遇到的非 `handler` 字段保留到语义层，
 * 由 [top.wcpe.allincore.dsl.compiler.semantic.SubscribeChecker] 统一报 E785，
 * 避免在 parser 一错即停影响诊断聚合。
 */
data class SubscribeBlockAst(
    val items: List<Item>,
    val unknownFields: List<UnknownField> = emptyList(),
    override val position: SourcePosition,
) : AstNode {

    /** 单个订阅条目：(namespace, topic) → handler 表达式。 */
    data class Item(
        val namespace: String,
        val topic: String,
        val handler: ExprAst,
        val position: SourcePosition,
    )

    /** 解析阶段遇到的未知字段名，由语义层报 E785。 */
    data class UnknownField(
        val namespace: String,
        val topic: String,
        val fieldName: String,
        val position: SourcePosition,
    )
}
